import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="Footer mt-4 text-center">
      <a
        href="https://github.com/kseniia-chepur/weather-app-react"
        target="_blank"
        rel="noreferrer"
      >
        Open-source code
      </a>
      <span> by Kseniia Chepur</span>
    </footer>
  );
}
